/**
 * Godot's Y-sort for TileMapLayer cells. `groupBySortY` buckets drawable cells by sort Y, from low
 * (back) to high (front), for the y-sort collector's y-sorted TileMapLayer children.
 */
import { compareCells } from './cellOrder';
import { mapToLocalPx } from './tilePlacement';
/**
 * Group cells by their sort Y: layer world Y + local pixel Y + the layer's and the tile's own
 * `y_sort_origin` (`tile_map_layer.cpp:547`).
 * Returns groups sorted by sortY ascending (low-Y drawn first = far back).
 * Cells with equal sortY are grouped together. Each row is one rendering quadrant
 * (`tile_map_layer.cpp:546-548`), so its cells sort as a quadrant's do.
 */
export function groupBySortY(cells, grid, layerYSortOrigin, layerWorldY) {
    // Map each cell to its sort Y.
    const keyed = [];
    const bucket = new Map();
    for (let i = 0; i < cells.length; i++) {
        const cell = cells[i];
        const localPx = mapToLocalPx(grid, cell.coords);
        const sortY = layerWorldY + localPx.y + layerYSortOrigin + cell.tileData.ySortOrigin;
        // Use exact float equality (Godot uses exact comparison).
        const existing = bucket.get(sortY);
        if (existing) {
            existing.push(cell);
        }
        else {
            bucket.set(sortY, [cell]);
        }
    }
    // Build groups sorted by sortY ascending (low-Y = far back).
    const sortKeys = [...bucket.keys()].sort((a, b) => a - b);
    for (let i = 0; i < sortKeys.length; i++) {
        const sortY = sortKeys[i];
        const groupCells = bucket.get(sortY).sort(compareCells);
        keyed.push({ sortY, cells: groupCells, treeOrder: i });
    }
    return keyed;
}
//# sourceMappingURL=tileYSort.js.map